let actionDuplicate = function(id) {
	this.$router.push({
		name: "InvoiceDuplicate",
		params: { idinv: id},
	});
};
export default actionDuplicate;
